<template>
    <main class="relative h-screen overflow-hidden bg-white md:bg-gray-100">
        <div class="flex items-start justify-between">
            <div>
                <div>
                    <div class="h-screen bg-gray-700 w-64  py-7 px-2 absolute inset-y-0 left-0 transform -translate-x-full md:relative md:translate-x-0 transition duration-200 ease-in-out z-50"
                        :class="{ 'translate-x-0': state.isSidebarOpen, '-translate-x-full': !state.isSidebarOpen }">
                        <!-- Sidebar content -->

                        <div class="flex flex-col md:items-center ">
                            <button @click="toggleSidebar"
                                class="black focus:outline-none md:hidden text-white text-lg mb-4 md:mb-0">
                                <font-awesome-icon :icon="['fas', 'times']" />
                            </button>
                            <SidebarItem />

                        </div>
                    </div>

                </div>
            </div>
            <div class="flex flex-col w-full pl-0 md:p-4 md:space-y-4">

                <header class="z-40 items-center w-full h-16 bg-white shadow-lg dark:bg-gray-700 rounded-2xl">

                    <div class="relative z-20 flex flex-col justify-center h-full px-3 mx-auto flex-center">
                        <div class="relative flex items-center justify-between w-full pl-1 lg:max-w-68 sm:pr-2 sm:ml-0">

                            <div class="hidden container relative left-0 z-50 md:flex items-center w-3/4 h-auto">

                                <div class="relative flex items-center w-full h-full lg:w-64 group">
                                    <div
                                        class="absolute z-50 items-center justify-center block w-auto h-10 p-3 pr-2 text-sm text-gray-500 uppercase cursor-pointer sm:hidden">
                                        <svg fill="none" class="relative w-5 h-5" stroke-linecap="round"
                                            stroke-linejoin="round" stroke-width="2" stroke="currentColor"
                                            viewBox="0 0 24 24">
                                            <path
                                                d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z">
                                            </path>
                                        </svg>
                                    </div>

                                    <input type="text"
                                        class="block w-full py-1.5 pl-10 pr-4 leading-normal rounded-2xl focus:border-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 ring-opacity-90 bg-gray-100 dark:bg-gray-800 text-gray-400 aa-input"
                                        placeholder="Search" />
                                    <div
                                        class="absolute right-0 hidden h-auto px-2 py-1 mr-2 text-xs text-gray-400 border border-gray-300 rounded-2xl md:block">
                                        +
                                    </div>

                                </div>
                            </div>
                            <div
                                class="relative flex items-center md:justify-end w-1/4 p-1 md:ml-5 mr-4 sm:mr-0 sm:right-auto">
                                <a href="#" class="relative block">
                                    <img v-if="schoolLogo" :src="schoolLogo" alt="School logo"
                                        class="mx-auto object-cover rounded-full h-10 w-10 " />
                                    <i v-else class="pi pi-graduation-cap text-primary" style="font-size: 2rem;"></i>
                                </a>
                            </div>
                            <div class="mx-4 md:hidden">
                                <button @click="toggleSidebar" class=" text-black">
                                    <font-awesome-icon :icon="['fas', 'bars']" />
                                </button>
                            </div>

                        </div>
                    </div>
                </header>

                <div class="h-screen overflow-y-auto pt-2  pl-2 pr-2  md:pt-0 md:pr-0 md:pl-0">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </main>

</template>

<script setup lang="ts">

import SidebarItem from '../components/TeacherDashboard/SidebarItem.vue';
import { useBranding } from '@/composables/useBranding';

const { schoolLogo } = useBranding();

const state = reactive({
  isSidebarOpen: false,
  activeRoute: null,
});

const toggleSidebar = () => {
  state.isSidebarOpen = !state.isSidebarOpen;
};

</script>
